import React, { useState, useEffect, useRef } from "react";
import strings from "../../utils/property-file/manageLeave.json";
import Modal from "react-bootstrap/Modal";
import constants from "../../utils/constants";
import { useForm } from "react-hook-form";
import "./scheduleHoliday.css";
import moment from "moment";
import api from "../../services/api"
import {  useNavigate } from "react-router-dom";
import RangeCalendar from "../rangeCalendar/rangeCalendar";
import { toast } from "react-toastify";
import SpinnerButtonMedium from "../button/SpinnerButtonMedium";
import PropTypes from "prop-types"

export default function EditHolidayPop(props) {
    const nav = useNavigate();
    const [openCalendar , setOpenCalendar] = useState(false);
    const [editingHoliday , setEditingHoliday] = useState(false);
    const [holidayType , setSelectedHolidayType] = useState("");
    const [selectedDateRange, setSelectedDateRange] = useState(null);
    const startDate = selectedDateRange ? (selectedDateRange.startDate?selectedDateRange.startDate._d:"") : "";
    const endDate = selectedDateRange ? (selectedDateRange.endDate?selectedDateRange.endDate._d:"") : "";
    const parsedStartDate = moment(startDate);
    const parsedEndDate = moment(endDate);
    const formattedStartDate = parsedStartDate.utc().format('DD/MM/YYYY');
    const formattedEndDate = parsedEndDate.utc().format('DD/MM/YYYY');
    const calendarRef = useRef();
    const selectedHolidayId=props.holidayId ?props.holidayId : "";
    const [holidayDetails ,setHolidayDetails] = useState(null);
    const [gettingHolidayInfo , setGettingHolidayInfo] = useState(true);

    useEffect(()=>{
      holidayInfo();
    },[])
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          calendarRef.current &&
          !calendarRef.current.contains(event.target)
        ) {
          setOpenCalendar(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [calendarRef]);
    
    const handleDateRangeSelection = (startDate, endDate) => {
      const allDatesInRange = getDatesInRange(startDate, endDate);
      setSelectedDateRange({
        startDate: startDate.utc(),
        endDate:endDate ? endDate.utc() : "",
        allDatesInRange: allDatesInRange.map(date => date.utc())
      });
    };
    
    const getDatesInRange = (startDate, endDate) => {
      const dates = [];
      let currentDate = moment(startDate);
      while (currentDate.isSameOrBefore(endDate, 'day')) {
        dates.push(moment(currentDate));
        currentDate = currentDate.add(1, 'day');
      }
      return dates;
    };
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();

      function formSubmit(data) {
        editHolidayInformation(data)
      }

      const editHolidayInformation = async(data)=>
      {
        try{
          setEditingHoliday(true);
          let dates = [];
          if (holidayType === strings.singleDay && selectedDateRange && selectedDateRange.startDate) {
            dates.push(selectedDateRange.startDate.toISOString());
          } else if (holidayType === strings.multipleDays && selectedDateRange && selectedDateRange.allDatesInRange) {
            dates = selectedDateRange.allDatesInRange.map(date => date.toISOString());
          }
          const body ={
            _id : selectedHolidayId,
            title : data.holidayTitle,
            description : data.holidayDes ? data.holidayDes : "",
            leaveType : holidayType,
            date :  dates==""? (holidayDetails ? holidayDetails[0].date : "") :dates
          } 
          const response =await api.editCompanyHoliday(body);
          if(response && response.data)
          {
            const data= JSON.parse(response.data);
            if(response.success)
            {
              toast.success(data.body , {toastId : "error13"})
              props.onHide();
              props.getHolidayCall();
            }
            else {
              toast.error(data.body ,{toastId : "error6"})
              if(response.status_code===440) {
                nav(constants.navigationLink.loginLink);
                localStorage.clear();
              }
            }
           
          }
          setEditingHoliday(false);
          
        }
        catch(error){
          setEditingHoliday(false);
        }
      }

      const holidayInfo = async()=>{
        try{
          const response = await api.getHolidayInfo(selectedHolidayId);
          if(response && response.data)
          {
            const data= JSON.parse(response.data);
            if(response.success)
            {
              setHolidayDetails(data.body);
              setSelectedHolidayType(data.body? data.body[0].leaveType : "");
            }
            else
            {
              if(response.status_code===440)
              {
                toast.error(data.body , {toastId : "error6"})
                localStorage.clear();
                nav(constants.navigationLink.loginLink);
              }
            }
            setGettingHolidayInfo(false);
          }
          else
          {
            setGettingHolidayInfo(false);
          }
        }
        catch(error){
          setGettingHolidayInfo(false);
        }
      }

  return (
   
        <div className="edit-holiday-main-container">
      <Modal
        {...props}
        size="lg"
        className="modal-container add-holiday-main-container"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header id="emp-det-modal-header" className="mt-5 modal-add-holiday-header">
          <Modal.Title id="contained-modal-title-center">
            {strings.editHolidayLabel}
            <button className="btn-close-modal" onClick={props.onHide}>
              <i className="ri-close-fill"></i>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-holiday-container ">
          { gettingHolidayInfo?<div className="edit-holiday-spinner"><SpinnerButtonMedium/> </div> : (holidayDetails!==null?
          (
          holidayDetails.map((key)=>{
            return(

       <form key={key._id}
                className="holiday-add-form"
                onSubmit={handleSubmit(formSubmit)}
              >
                 
                <div className="form-floating input-gap">
                  <input
                    {...register("holidayTitle", {
                      required: strings.holidayRequiredLabel,
                      minLength: {
                        value: 2,
                        message: strings.minChar,
                      },
                      maxLength: {
                        value : 30,
                        message : strings.maxChar
                      },
                      pattern: {
                        value: constants.inputPattern.patternWithoutSpaceThird,
                        message: strings.validValue,
                      },
                    })}
                    defaultValue={holidayDetails ?(holidayDetails[0].title ? holidayDetails[0].title : ""):""}
                    type="text"
                    className={
                      errors.holidayTitle
                        ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                        : "form-control validateEmail email-input pb-0 add-employee-input-text"
                    }
                    placeholder=" "
                    autoComplete="off"
                  />
                  <label
                    htmlFor="floating-input"
                    className="text-light input-place"
                  >
                    {strings.holidayTitle}
                  </label>
                  <div className="form-validation">
                    <small>
                      {errors.holidayTitle && (
                        <span className="position-absolute"> 
                          <strong className="me-1">&#9432;</strong>
                          {errors.holidayTitle.message}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="form-floating input-gap">
                  <input
                    {...register("holidayDes", {
                      required: false,
                      pattern: {
                        value: constants.inputPattern.patternWithoutSpaceThird,
                        message: strings.validValue,
                      },
                      maxLength :{
                        value: 200,
                        message : strings.descriptionErrorLabel
                      }
                    })}
                    type="text"
                    defaultValue={holidayDetails ?(holidayDetails[0].description!=='' ? holidayDetails[0].description : ""):""}
                    className={
                      errors.holidayDes
                        ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                        : "form-control validateEmail email-input pb-0 add-employee-input-text"
                    }
                    placeholder=" "
                    autoComplete="off"
                  />
                  <label
                    htmlFor="floating-input"
                    className="text-light input-place"
                  >
                    {strings.holidayDescription}
                  </label>
                  <div className="form-validation">
                    <small>
                      {errors.holidayDes && (
                        <span className="position-absolute">
                        <strong className="me-1 ">&#9432;</strong>
                        {errors.holidayDes.message}
                      </span>
                      )}
                    </small>
                  </div>
                </div>
    
                <div className="select-holiday-type">
                  <div className="d-inline option-add-holiday m-0 "  onClick={() => setSelectedHolidayType(strings.singleDay)}>
                    <input
                      type="radio"
                      name="option"
                      value={strings.singleDay}
                      defaultChecked={holidayDetails ? (holidayDetails[0].leaveType ?strings.singleDay===holidayDetails[0].leaveType : false) : false}
                      {...register("option", { required: true })}
                      id="singleDayOption"
                    />
                    <label className="holiday-label" htmlFor="singleDayOption">{strings.singleDay}</label>
                  </div>
                  <div className="d-inline option-add-holiday"  onClick={() => setSelectedHolidayType(strings.multipleDays)}>
                    <input
                      type="radio"
                      name="option"
                      value={strings.multipleDays}
                      defaultChecked={holidayDetails ? (holidayDetails[0].leaveType ?strings.multipleDays===holidayDetails[0].leaveType : false) : false}
                      {...register("option", { required: true })}
                      id="multiDays"
                    />
                    <label className="holiday-label" htmlFor="multiDays">{strings.multipleDays}</label>
                  </div>
                  {errors.option && (
                    <div className="form-validation">
                      <small>
                        <span className="position-absolute">
                          <strong className="me-1">&#9432;</strong>
                          {strings.selectOption}
                        </span>
                      </small>
                    </div>
                  )}
                  {holidayType? (holidayType===strings.singleDay?((<div className="form-floating input-gap" ref={calendarRef}>
                 <input
              {...register("holidayDate", { required: true })}
              onClick={() => setOpenCalendar(true)}
              id="holidayDate"
              className={
                errors.holidayDate
                  ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                  : "form-control validateEmail email-input pb-0 add-employee-input-text"
              }
              placeholder=" "
              autoComplete="off"
              value={
                selectedDateRange && formattedStartDate
                  ? formattedStartDate
                  : holidayDetails
                  ? holidayDetails[0].date
                    ? moment
                        .utc(holidayDetails[0].date[0])
                        .format("DD/MM/YYYY")
                    : ""
                  : ""
              }
              onChange={((e)=>{const inputValue =
                selectedDateRange && formattedStartDate
                  ? formattedStartDate
                  : strings.selectHoliday;
              e.target.value = inputValue;})}
            />
            {openCalendar && <RangeCalendar disableRange={holidayType===strings.singleDay}  onDateRangeSelection={handleDateRangeSelection}/>}
                 </div>
                  )):(<div className="form-floating input-gap" ref={calendarRef}>
                  <input
               {...register("holidayDate", { required: true })}
               onClick={() => setOpenCalendar(true)}
               id="holidayDate"
               className={
                 errors.holidayDate
                  ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                  : "form-control validateEmail email-input pb-0 add-employee-input-text"
               }
               placeholder=" "
               autoComplete="off"
              value={
                selectedDateRange && formattedStartDate
                ? formattedStartDate+ (formattedEndDate ? (formattedEndDate=== strings.invalidDateLabel ? "": strings.toLabel  +formattedEndDate):"")
                : holidayDetails
                ? holidayDetails[0].date
                  ? moment
                      .utc(holidayDetails[0].date[0])
                      .format("DD/MM/YYYY") +
                      ' to ' +
                      moment.utc(holidayDetails[0].date[holidayDetails[0].date.length - 1]).format('DD/MM/YYYY')
                  : ""
                : ""
              }
              onChange={((e)=>{const inputValue =
                selectedDateRange && formattedStartDate
                  ? `${formattedStartDate} to ${formattedEndDate}`
                  : strings.selectHoliday;
              e.target.value = inputValue;})}
              
             />
             {openCalendar && <RangeCalendar  onDateRangeSelection={handleDateRangeSelection}/>}
                  </div>)) :""}
             <button type="submit" className="d-block mt-5 submit-holiday-btn mb-5" disabled={editingHoliday} >
              {editingHoliday ? <SpinnerButtonMedium/> : strings.updateLabel}
                  </button>
                </div>
              </form>
             
            )
          })
        ):""
         )}
        </Modal.Body>
      </Modal>
 
    </div>
  )
}

EditHolidayPop.propTypes = {
holidayId : PropTypes.any.isRequired,
onHide : PropTypes.func.isRequired,
getHolidayCall : PropTypes.func.isRequired
}